import styled from 'styled-components'
import { Button } from '@mui/material'
import { breakpoints } from 'theme'

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '1280px',
  rowGap: '1rem',
  paddingBottom: 'calc(2vh + 24px)',
})

export const CardBox = styled.div({
  marginBottom: '24px',
  borderRadius: '8px',
  background: '#FFF',
  boxShadow: '0px 4px 4px 0px rgba(27, 81, 164, 0.04)',
  padding: '24px',
  '&:last-child': {
    marginBottom: 0,
  },
})

export const DropdownContainer = styled.div({
  marginBottom: 20,
})

export const ContentWrapper = styled.div({
  backgroundColor: '#f9fafb',
  width: '100%',
  maxWidth: '1280px',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '1rem',
})

export const CenteredCard = styled.div({
  backgroundColor: '#FFFFFF',
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
  padding: '1rem',
})

export const IconCircle = styled.div({
  width: '100px',
  height: '100px',
  borderRadius: '99px',
  padding: '13px 12px',
  border: '1px solid #E5E7EB',
  background: '#FFFFFF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1.5rem',
  marginLeft: 'auto',
  marginRight: 'auto',
})

export const HeaderGroup = styled.div({
  width: '100%',
  height: '80px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: '2rem',
})

export const Heading = styled.h6({
  width: '100%',
  height: '30px',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: '30px',
  color: '#262626',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
  textAlign: 'center',
})

export const Description = styled.p({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '150%',
  letterSpacing: '0%',
  textAlign: 'center',
  verticalAlign: 'bottom',
  color: '#777777',
  marginBottom: '2rem',
  maxWidth: '32rem',
  marginLeft: 'auto',
  marginRight: 'auto',
})

export const PrimaryButton = styled(Button)({
  height: 39,
  borderRadius: 6,
  padding: '8px 16px',
  gap: 8,
  '&.MuiButton-root': {
    textTransform: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 15,
    lineHeight: '150%',
    letterSpacing: 0,
    color: '#FEFEFE',
  },
  '&.MuiButton-contained': {
    backgroundColor: '#1B51A4',
    '&:hover': {
      backgroundColor: '#17448B',
    },
  },
})

export const FeatureGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  gap: '1.5rem',
  marginTop: '3rem',
  paddingTop: '2rem',
  borderTop: '1px solid #E5E7EB',
})

export const Feature = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
})

export const CheckIconCircle = styled.div({
  width: '32px',
  height: '32px',
  borderRadius: '8px',
  padding: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#DCFCE7',
  color: '#16A34A',
  fontSize: '0.875rem',
  gap: '4px',
})

export const FeatureTitle = styled.p({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '150%',
  letterSpacing: '0%',
  verticalAlign: 'bottom',
  color: '#262626',
  margin: 0,
})

export const FeatureDescription = styled.p({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '150%',
  letterSpacing: '0%',
  verticalAlign: 'bottom',
  color: '#777777',
  margin: 0,
})

export const WebsiteStatusTitle = styled.h2({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '28px',
  letterSpacing: 0,
  verticalAlign: 'bottom',
  color: '#292929',
  marginBottom: '0.5rem',
})

export const WebsiteStatusDescription = styled.p({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '150%',
  letterSpacing: 0,
  verticalAlign: 'bottom',
  color: '#777777',
  marginBottom: '1rem',
})

export const WebsiteStatusInfo = styled.div({
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: 14,
  lineHeight: '150%',
  letterSpacing: 0,
  verticalAlign: 'bottom',
  color: '#777777',
  marginBottom: '1rem',
})

export const WebsiteDateText = styled.span({
  fontWeight: 400,
  color: '#777777',
})

export const WebsiteUrlContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  marginBottom: '1rem',
})

export const WebsiteLabel = styled.div({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '150%',
  letterSpacing: 0,
  color: '#262626',
  marginBottom: '0.5rem',
})

export const ChilipiperEmbed = styled.iframe({
  width: '340px',
  height: '500px',
  [`@media ${breakpoints.lg}`]: {
    width: '560px',
    height: '700px',
  },
  [`@media ${breakpoints.xl}`]: {
    width: '560px',
    height: '700px',
  },
})